import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { CaptureInfoService } from '@yol-digital/ms-client';
import { catchError, EMPTY, throwError } from 'rxjs';
import { ENVIRONMENT_URLS_CONFIG_TOKEN } from 'app-initialization';
import { BrandService } from 'brand';
import { LanguageService } from 'language';
import { ToastService } from 'toast';
import { TranslateService } from 'translate';
import Api = CaptureInfoService.Api;

@Injectable({
  providedIn: 'root',
})
export class ContestService {
  private http = inject(HttpClient);
  private languageService = inject(LanguageService);
  private toastService = inject(ToastService);
  private translateService = inject(TranslateService);
  private brandService = inject(BrandService);
  private config = inject(ENVIRONMENT_URLS_CONFIG_TOKEN);
  private api = new Api(this.config.newMicroServiceEndpoint, this.http);

  public submitContestData(contestDetails: Omit<CaptureInfoService.ContestDetailReq, 'language' | 'brand'>) {
    const params: CaptureInfoService.ContestDetailReq = {
      trackingCookie: '',
      brand: this.brandService.brand,
      language: this.languageService.current,
      ...contestDetails,
    };

    return this.api.public.submitContestDetails(params).pipe(
      catchError(err => {
        if (!err?.wasCaught) {
          console.error(err);
          this.toastService.add(this.translateService.getTranslation(['server_error']), false);
          return throwError(() => err);
        }
        return EMPTY;
      })
    );
  }
}
